/**
 * CampaignType enum
 * Defines the type of campaign leaderboard.
 * Matches Flutter implementation: lib/domain/enums/campaign_type.dart
 *
 * Ordinal order MUST match Flutter exactly: a campaign's numeric `type` field
 * maps to this enum via index, exactly like Dart's `CampaignType.values[type]`
 * (lib/presentation/bottom_sheet/campaign_ranking_bottom_sheet.dart:50). A wrong
 * order silently sends the user leaderboard to a content campaign.
 */
export enum CampaignType {
  usersMostSubscribers = 0,
  contentMostLikes = 1,
  contentMostCoins = 2,
}
